const t = { last_updated: "Laatst herzien", Series_type: "Series", "How to guide_type": "Gids", FAQ_type: "Standaard" }, e = {
  articles: t
};
export {
  t as articles,
  e as default
};
//# sourceMappingURL=help-center-knowledge-anatomies33.js.map
